var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLftw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1903_1777)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    transform: "matrix(-1 0 0 1 24 0)",
    fill: "#787878",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3215 16.8021L8.8756 12.3694C8.82283 12.3166 8.78536 12.2595 8.76319 12.1979C8.74103 12.1363 8.73013 12.0704 8.73048 12C8.73048 11.9296 8.74138 11.8637 8.76319 11.8021C8.78501 11.7405 8.82247 11.6834 8.8756 11.6306L13.3215 7.1847C13.4446 7.06157 13.5986 7 13.7832 7C13.9679 7 14.1263 7.06596 14.2582 7.19789C14.3901 7.32982 14.4561 7.48373 14.4561 7.65963C14.4561 7.83553 14.3901 7.98945 14.2582 8.12137L10.3796 12L14.2582 15.8786C14.3813 16.0018 14.4429 16.1536 14.4429 16.334C14.4429 16.5145 14.3769 16.6705 14.245 16.8021C14.1131 16.934 13.9591 17 13.7832 17C13.6073 17 13.4534 16.934 13.3215 16.8021Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1903_1777",
    x: -54,
    y: -54,
    width: 132,
    height: 132,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 27
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1903_1777"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1903_1777",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLftw);
export default __webpack_public_path__ + "static/media/lftw.de0a7a5c8fc0657cc587ffd88f953351.svg";
export { ForwardRef as ReactComponent };